import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog'
import { UnespCoreMessageService } from '@unesp/core'
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes'
import { FormControl, Validators } from '@angular/forms'
import { MatChipInputEvent, MatChipGrid } from '@angular/material/chips'
import { UnespConfirmDialogComponent, UnespConfirmDialogModel } from '@unesp/shared'
import { PropgService } from 'src/app/services/propg-service'

export interface DisciplinaData {
  id: number
  nome: string
  responsaveis: string
}

@Component({
  selector: 'app-propg-editar-responsaveis-inscricao',
  templateUrl: 'propg-editar-responsaveis-inscricao.component.html',
  styleUrls: ['./propg-editar-responsaveis-inscricao.component.css'],
  standalone: false
})
export class PropgEditarResponsaveisInscricaoComponent implements OnInit {
  readonly chipsSeparatorKeys = [ENTER, COMMA, SPACE] as const
  responsaveisChips: string[] = []
  chipPlaceHolder: string = '123.456.789-00...'
  erroChipsMsg: string = 'Digite os 11 digitos do CPF'

  @ViewChild('responsaveisChipList') responsaveisChipList: MatChipGrid | undefined

  matChipFC: FormControl = new FormControl({ value: '', disabled: true })
  responsaveisChipListFC: FormControl = new FormControl('', [Validators.pattern(/^\d{11}$/)])

  constructor(
    private unespCoreMessageService: UnespCoreMessageService,
    private propgService: PropgService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PropgEditarResponsaveisInscricaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DisciplinaData
  ) {}

  ngOnInit(): void {
    if (this.data.responsaveis) {
      this.data.responsaveis.split(',').forEach(res => {
        const value = res.trim()
        if (value)
          this.responsaveisChips.push(
            `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(6, 9)}-${value.substring(9)}`
          )
      })
    }
  }

  addChip(event: MatChipInputEvent): void {
    if (this.responsaveisChipListFC.invalid) {
      this.responsaveisChipListFC.markAsTouched()
      return
    }

    const value = (event.value || '').trim()
    if (value) {
      this.responsaveisChipListFC.disable()
      this.adicionarResponsavel(value)
    }
  }

  removeChip(resp: string): void {
    const index = this.responsaveisChips.indexOf(resp)

    if (index >= 0) {
      this.responsaveisChipListFC.disable()
      this.removerResponsavel(index, resp)
    }
  }

  adicionarResponsavel(cpf: string): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Confirmar adição do CPF: ${cpf} como responsável pela inscrição #${this.data.id}?`
    )
    this.dialog
      .open(UnespConfirmDialogComponent, { data: confirmDialog })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.propgService.adicionarResponsavelInscricao(this.data.id, cpf.replace(/\D/g, '')).subscribe({
            next: resp => {
              if (resp != 1) return
              this.responsaveisChips.push(cpf)
              this.unespCoreMessageService.showMessageSuccess(
                `CPF: ${cpf} adicionado como responsável pela inscrição #${this.data.id}`
              )
            },
            complete: () => {
              this.responsaveisChipListFC.reset()
              this.responsaveisChipListFC.enable()
            },
          })
        } else this.responsaveisChipListFC.enable()
      })
  }

  removerResponsavel(idx: number, cpf: string): void {
    const confirmDialog = new UnespConfirmDialogModel(
      'Atenção',
      `Confirmar exclusão do CPF: ${cpf} como responsável pela inscrição #${this.data.id}?`
    )
    this.dialog
      .open(UnespConfirmDialogComponent, { data: confirmDialog })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.propgService.excluirResponsavelInscricao(this.data.id, cpf.replace(/\D/g, '')).subscribe({
            next: resp => {
              if (resp != 1) return
              this.responsaveisChips.splice(idx, 1)
              this.unespCoreMessageService.showMessageSuccess(
                `CPF: ${cpf} removido como responsável pela inscrição #${this.data.id}`
              )
            },
            complete: () => this.responsaveisChipListFC.enable(),
          })
        } else this.responsaveisChipListFC.enable()
      })
  }

  close() {
    this.dialogRef.close()
  }
}
